import React from 'react';

const getInitialName = (name: string): string => {
    if (!name) return '';

    // Remove parênteses e tudo dentro deles
    const cleanedName = name.replace(/\([^)]*\)/g, '').trim();

    // Divide e filtra apenas palavras com letras (ignora números e símbolos)
    const nameParts = cleanedName
        .split(' ')
        .map(part => part.trim())
        .filter(part => /^[A-Za-zÀ-ÿ]+$/.test(part)); // aceita letras acentuadas

    const firstInitial = nameParts[0]?.[0] || '';
    const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '';

    return (firstInitial + lastInitial).toUpperCase();
};

interface AvatarUserProps {
    name: string;
    photoURL: string | undefined;
    size?: string;
}

export default function AvatarUser({ name, photoURL, size = 'w-6' }: AvatarUserProps) {
    return (
        <div className="avatar placeholder">
            {photoURL ? (
                <div className={`${size} rounded-full`}>
                    <img src={photoURL} alt="Avatar" />
                </div>
            ) : (
                <div className={`${size} rounded-full bg-neutral font-bold text-neutral-content flex items-center justify-center text-xs`}>
                    <span>{getInitialName(name)}</span>
                </div>
            )}
        </div>
    );
}
